import { AnimatePresence, motion } from 'framer-motion';
import Shine from '../../assets/images/backgrounds/chest-modal-shine-bg.png';
import Drawer from '../../Components/Drawer';
import { TChestRewardHistory } from '../../types';
import ReceivedChestReward from '../ReceivedChestReward';

type TReceivedChestRewardModalProps = {
  open: boolean;
  reward?: TChestRewardHistory
  onCollect: () => void;
}

function ReceivedChestRewardModal({
  open, reward, onCollect,
}: TReceivedChestRewardModalProps) {
  return (
    <Drawer
      open={open}
      side="bottom"
      wrapperClassName="flex flex-col shadow-xl rounded-t-[20px] z-[2000] relative bg-receivedChestRewardModalBg pt-6 px-4 pb-[52px]  overflow-hidden"
      hideClose
    >
      <div className="absolute z-[-1] inset-0 w-full h-full before:bg-receivedChestRewardModalBg before:w-full before:h-full before:absolute before:inset-0 before:opacity-[0.6]">
        <img src={Shine} alt="shine" className="w-full h-full" />
      </div>
      <AnimatePresence>
        {open && reward && (
        <motion.div initial={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
          <ReceivedChestReward reward={reward} onCollect={onCollect} classNames={{ button: 'mt-[26px]', rewards: { wrapper: '' }, icons: { wrapper: 'max-w-[211px]' } }} />
        </motion.div>
        )}
      </AnimatePresence>
    </Drawer>
  );
}

export default ReceivedChestRewardModal;
